export default __webpack_public_path__ + "static/media/imagen_bohemian.4a5baaea.jpg";